import { render, staticRenderFns } from "./editVehicle.vue?vue&type=template&id=b8000af4&scoped=true&"
import script from "./editVehicle.vue?vue&type=script&lang=js&"
export * from "./editVehicle.vue?vue&type=script&lang=js&"
import style0 from "./editVehicle.vue?vue&type=style&index=0&id=b8000af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8000af4",
  null
  
)

export default component.exports